import React from "react";
import { DateFilterDropdown } from "../../../components";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

const getDateFilterLabel = (type) => {
  const labels = {
    today: "Today's Data",
    thisWeek: "This Week's Data",
    lastWeek: "Last Week's Data",
    thisMonth: "This Month's Data",
    lastMonth: "Last Month's Data",
    thisYear: "This Year's Data",
    all: "All Time Data",
    singleDate: "Single Date",
    customRange: "Custom Range",
  };

  return labels[type] || labels.thisWeek;
};

const DashboardToolbar = ({ dashboard, dateFilter, onDateFilterChange }) => {
  const dateFilterTrigger = (
    <div className="flex items-center cursor-pointer font-semibold">
      <span>{getDateFilterLabel(dateFilter?.type)}</span>
      <ChevronDownIcon className="h-3 w-3 ml-1" />
    </div>
  );

  return (
    <div className="flex flex-col gap-3 border-b bg-white p-3 md:flex-row md:items-center md:justify-between">
      <div>
        <h1 className="text-lg font-bold text-gray-800">
          {dashboard?.name || "Dashboard"}
        </h1>
        {dashboard?.description && (
          <p className="text-sm text-gray-500">{dashboard.description}</p>
        )}
      </div>
      <DateFilterDropdown
        align="left"
        trigger={dateFilterTrigger}
        onChange={onDateFilterChange}
        value={dateFilter}
      />
    </div>
  );
};

export default DashboardToolbar;
